import { connectFela } from '../../dependencies';
import DeleteMembershipButton from './DeleteMembershipButton';
import * as styles from './DeleteMembershipButton.styles';

export default connectFela(styles)(DeleteMembershipButton);
